export function accordion() {
    const accordionBlock = $(".accordion");

    accordionBlock.on("click", ".title", function (e) {
        const accordion = $(this).parents(".accordion");
        const parent = $(this).parent();
        const content = parent.find('.content-wrap');
        const $tabbedContentPlaceholder = $(this).parents('.has-tabbed-accordion').find('.tabbed-content-placeholder');

        if (parent.hasClass("active")) {
            if (!accordionBlock.closest('.has-tabbed-accordion').length) {
                parent.removeClass("active");
                content.slideUp();
            }
            if ($tabbedContentPlaceholder) {
                // $tabbedContentPlaceholder.html('');
            }
        } else {
            accordion.find(".accordion-block").removeClass("active").find(".content-wrap").slideUp();
            parent.addClass("active");
            content.slideDown();
            if ($tabbedContentPlaceholder) {
                $tabbedContentPlaceholder.html('');
                setTimeout(function () {
                    $tabbedContentPlaceholder.append(content.clone());
                }, 200);
                setTimeout(function () {
                    $tabbedContentPlaceholder.find('.content-wrap').addClass('showed');
                }, 300)
            }
        }
        e.preventDefault();
    });

    accordionBlock.each(function () {
        const $this = $(this);

        setTimeout(function () {
            const firstItem = $this.find(".accordion-block:first-child");
            const content = firstItem.find('.content-wrap').clone();

            if ($this.parents('.has-tabbed-accordion').length) {
                $this.parents('.has-tabbed-accordion').find('.tabbed-content-placeholder').append(content);
            }

            if (!firstItem.hasClass("active")) {
                firstItem.find('.title').trigger('click');
            }
        }, 100);
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js